import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import EmailIcon from 'mdi-react/EmailIcon';
import CheckboxMarkedCircleIcon from 'mdi-react/CheckboxMarkedCircleIcon';
import { Card, CardBody } from '@/shared/components/Card';
import { Button } from '@/shared/components/Button';
import { colorAccent, colorGray } from '@/utils/palette';
import { right } from '@/utils/directions';
import { useLocation, useSearchParams } from 'react-router';

const EmailConfirmationCard = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const email = location.state?.email || searchParams.get('email');

    return (
        <Col md={12}>
            <Card>
                <CardBody>
                    <EmailConfirmationWrap>
                        <EmailConfirmationIcon>
                            <EmailConfirmationSvg />
                            <EmailConfirmationCheckSvg />
                        </EmailConfirmationIcon>
                        <EmailConfirmationTitle>Check your email!</EmailConfirmationTitle>
                        <EmailConfirmationSubtitle>Login link has been sent to {email}</EmailConfirmationSubtitle>
                        <EmailConfirmationHelper>
                            If you didn't get the email, check your spam. also make sure your email is correct. If you faced any issue, please get in
                            touch with us for assistance.
                        </EmailConfirmationHelper>
                        <Button variant="primary" className="mt-3">
                            Contact to Support
                        </Button>
                    </EmailConfirmationWrap>
                </CardBody>
            </Card>
        </Col>
    );
};

export default EmailConfirmationCard;

const EmailConfirmationWrap = styled.div`
    max-width: 500px;
    margin: auto;
    min-height: calc(100vh - 185px);
    text-align: center;
`;

const EmailConfirmationIcon = styled.div`
    margin: 0 auto;
    padding-top: 75px;
    position: relative;
    width: 120px;

    @media screen and (min-width: 576px) {
        padding-top: 155px;
    }
`;

const EmailConfirmationSvg = styled(EmailIcon)`
    fill: ${colorGray};
    opacity: 0.16;
    width: 120px;
    height: 120px;
`;

const EmailConfirmationCheckSvg = styled(CheckboxMarkedCircleIcon)`
    fill: ${colorAccent};
    height: 40px;
    width: 40px;
    position: absolute;
    ${right}: 0;
    top: 160px;
`;

const EmailConfirmationTitle = styled.h3`
    margin-bottom: 15px;
    color: ${colorGray};
`;

const EmailConfirmationSubtitle = styled.p`
    color: ${colorGray};
    font-size: 18px;
    line-height: 24px;
`;

const EmailConfirmationHelper = styled.p`
    color: ${colorGray};
    font-size: 16px;
    line-height: 24px;
`;
